
import { defineComponent, ref, computed, watch } from "vue";
import { useStore } from "vuex";
import { Actions } from "@/store/enums/StoreEnums";

export default defineComponent({
  name: "Images",
  props: {
    formDataTemp: {
      type: Object,
      required: true,
    },
  },
  setup(props, { emit }) {
    const store = useStore();
    const formData = ref<Record<string, unknown>>(props.formDataTemp);
    watch(() => props.formDataTemp, value => {
      formData.value = {...value}
    })
    const document = ref<string | unknown>("");
    const tempImageLogo = ref<string>("");
    const handleImageUpload = async (event) => {
      try {
        const file = event.target.files[0];
        const formData = new FormData();
        formData.append("file", file);
        const response = await store.dispatch(Actions.UPLOAD_FILE, formData);
        if (!response.includes("https://")) throw new Error("error in api");
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
          if (event.target.name == "logo")
            tempImageLogo.value = reader.result as string;
        };
        const tempEvent = {
          target: {
            name: event.target.name,
            value: response,
          },
        };
        fieldChanged(tempEvent);
      } catch (err) {
        console.log(err);
      }
    };
    const fieldChanged = async (event) => {
      formData.value[event.target.name] = event.target.value;
      emit("form-data", formData.value);
      try {
        const response = await store.dispatch(Actions.CREATE_BUSINESS_DRAFT, {
          business: JSON.stringify(formData.value),
        });
        if (response !== true) throw new Error("error in API");
      } catch (err) {
        console.log({ err });
      }
    };
    return {
      document,
      formData,
      fieldChanged,
      handleImageUpload,
      tempImageLogo,
    };
  },
});
